<!-- <div class="w-full relative  flex flex-col  " id="home"
  style="overflow-x: hidden; width: 100%; min-width: fit-content;"> -->

<div class="overflow-hidden w-full   ">
  <app-home-carousel2 class="!max-h-[50vh] md:h-auto"></app-home-carousel2>
 

  <div class="p-2 md:p-8 relative"> 

    <div class="container py-2 pt-1 mx-auto">
      <div class="flex flex-wrap w-full mb-2">
        <div class="lg:w-1/3 w-full mb-6 lg:mb-0">
          <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-500">
            Latest Additions
          </h1>
          <div class="h-1 w-20 bg-[#ff4d06] rounded"></div>
        </div>
        <span class="lg:w-2/3 w-full leading-relaxed text-gray-500">
          <h1>
            Next-Gen Tech Lands at Softnet Computers, Sri Lanka's Top Computer
            Store!
          </h1>
          <p>
            Upgrade your game with the hottest tech in Sri Lanka! Unleash
            mind-blowing graphics with the arrival of next-generation graphics
            cards. For the productivity powerhouses, explore the innovative
            features of our latest laptops. We've also got a fresh stock of
            cutting-edge peripherals to take your setup to the next level. We
            are the leading computer store in Sri Lanka, offering a wide
            selection of the latest tech at competitive prices.
          </p>
        </span>
      </div>
      <!-- <app-product-grid1 *ngIf="filteredItems.length>0" [filteredItems]="filteredItems"></app-product-grid1> -->

      <!-- <div class="container px-5 py-16 pb-8 pt-4 mx-auto"> -->
      <div
        class="container px-5 py-16 pb-8 pt-4 mx-auto grid justify-stretch xs:grid-cols-1 sm:grid-cols-1 md2:grid-cols-1 md:grid-cols-1 lg2:grid-cols-2 lg:grid-cols-2 xl2:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5">
        @for (item of newArrivalsArr; track $index) {
        <app-prod-card [isDark]="true" [item]="item" class="w-full flex"></app-prod-card>

        }
      </div>
      <!-- </div> -->
    </div>

    <div class="container py-2 pt-1 mx-auto">
      <div class="flex flex-wrap w-full mb-2">
        <div class="lg:w-1/3 w-full mb-6 lg:mb-0">
          <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-500">
            Exclusive Deals
          </h1>
          <div class="h-1 w-20 bg-[#ff4d06] rounded"></div>
        </div>
        <span class="lg:w-2/3 w-full leading-relaxed text-gray-500">
          <h1>
            Unbeatable Tech Deals in Sri Lanka: Save Big at Softnet Computers,
            Negombo!
          </h1>
          <p>
            Look no further than Softnet Computers in Negombo! We offer a
            treasure trove of deals on all your tech essentials. Score
            incredible markdowns on the latest laptops and desktops, perfect for
            boosting your productivity or entertainment. Need a new keyboard,
            mouse, or monitor? We've got sizzling savings on peripherals to
            supercharge your setup. Plus, upgrade your software with exclusive
            discounts – find the perfect program to fit your needs without
            overspending. But hurry, these deals won't last forever! New offers
            are added regularly, so keep checking back at Softnet Computers to
            discover the latest tech steals in Negombo, Sri Lanka.
          </p>
        </span>
      </div>
      <!-- <app-product-grid1
          *ngIf="filteredItemsDiscounted.length > 0"
          [filteredItems]="filteredItemsDiscounted"
        ></app-product-grid1> -->

      <!-- <div class="container px-5 py-16 pb-8 pt-4 mx-auto"> -->
      <div
        class="container px-5 py-16 pb-8 pt-4 mx-auto grid justify-stretch xs:grid-cols-1 sm:grid-cols-1 md2:grid-cols-1 md:grid-cols-1 lg2:grid-cols-2 lg:grid-cols-2 xl2:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5">
        @for (item of dealsArr; track $index) {

        <app-prod-card [isDark]="true" [item]="item" class="w-full flex"></app-prod-card>

        }
      </div>
      <!-- </div> -->
    </div>

    <div *ngIf="unlockElements" class="container px-5 py-8 pt-2 mx-auto animate__animated animate__fadeIn"
      style="--animate-delay: 2s;">
      <h1 class="sm:text-3xl text-2xl font-medium title-font text-center text-gray-500 mb-10">
        Why you should <br class="hidden sm:block" />choose us?
      </h1>
      <div class="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 md:space-y-0 space-y-6">
        <div class="p-4 md:w-1/3 flex">
          <div
            class="w-16 h-16 inline-flex items-center justify-center rounded-full bg-orange-100 mb-4 flex-shrink-0 p-2">
            <!-- <div class="w-12 h-12 bg-orange-300 justify-center rounded-full p-2"> -->
            <img src="../../../assets/icons/icons8-warranty-100 (1).png" alt="Quick: Stress-Free Warranty Service"
              loading="lazy" style="object-fit: contain; object-position: center;" />
            <!-- </div> -->
          </div>
          <div class="flex-grow pl-6">
            <h2 class="text-white text-lg title-font font-medium mb-2">
              Quick: Stress-Free Warranty Service
            </h2>
            <p class="leading-relaxed text-base text-gray-600">
              Warranty worries? Relax! Our Stress-Free service makes claims
              quick, secure, & hassle-free. We guide you through the process &
              get repairs done fast. Let us handle it all, so you can focus on
              what matters.
            </p>
          </div>
        </div>
        <div class="p-4 md:w-1/3 flex">
          <div
            class="w-16 h-16 inline-flex items-center justify-center rounded-full bg-orange-100 mb-4 flex-shrink-0 p-2">
            <!-- <div class="w-12 h-12 bg-orange-300 justify-center rounded-full p-2"> -->
            <img src="../../../assets/icons/icons8-positive-review-100.png" alt="Trust: From Handshake to High Five"
              loading="lazy" style="object-fit: contain; object-position: center;" />
            <!-- </div> -->
          </div>
          <div class="flex-grow pl-6">
            <h2 class="text-white text-lg title-font font-medium mb-2">
              Trust: From Handshake to High Five
            </h2>
            <p class="leading-relaxed text-base text-gray-600">
              From handshake to high five, we've built a lasting partnership!
              Years of trust and collaboration have brought us to this point of
              success. Let's celebrate the journey and keep reaching new heights
              together.
            </p>
          </div>
        </div>
        <div class="p-4 md:w-1/3 flex">
          <div
            class="w-16 h-16 inline-flex items-center justify-center rounded-full bg-orange-100 mb-4 flex-shrink-0 p-2">
            <!-- <div class="w-12 h-12 bg-orange-300 justify-center rounded-full p-2"> -->
            <img src="../../../assets/icons/icons8-trust-100.png" alt="Security: Shop Worry-Free" loading="lazy"
              style="object-fit: contain; object-position: center;" />
            <!-- </div> -->
          </div>
          <div class="flex-grow pl-6">
            <h2 class="text-white text-lg title-font font-medium mb-2">
              Security: Shop Worry-Free
            </h2>
            <p class="leading-relaxed text-base text-gray-600">
              Shop Worry-Free! We prioritize the security of your data and
              transactions with industry-leading safeguards. Enjoy peace of mind
              knowing you're in safe hands.
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- *ngIf="unlockElements" -->
    <app-brands-we-do class="animate__animated animate__fadeIn" style="--animate-delay: 2s;"></app-brands-we-do>
    <!-- *ngIf="unlockElements" -->
    <app-videos></app-videos>
  </div>
  <app-home-contact-us class="animate__animated animate__fadeIn" style="--animate-delay: 2s;"></app-home-contact-us>

  <app-footer></app-footer>
  <!---->
</div>